import { Button, Modal, ModalContext } from "dash-ui";
import { useContext } from "react";

function ConfirmMediaKitChangesModal() {
  const { isOpenCurrent, payload, toggleModal } = useContext(ModalContext);
  const isOpen = !!isOpenCurrent["ConfirmMediaKitChangesModal"];

  const onSubmit = payload?.onSubmit;
  const loading = payload?.loading;

  const closeModal = () => {
    toggleModal(false, "ConfirmMediaKitChangesModal");
  };

  return (
    <Modal
      closeIcon
      w="fit-content"
      isOpen={isOpen}
      onRequestClose={closeModal}
      maxWidth={"90%"}
      title="Confirm your changes">
      <div className="max-w-sm text-sm mt-4 mb-6">
        ⚠️ This action will{" "}
        <strong>{payload?.mode} all the property's media files</strong>{" "}
        {payload?.mode === "add" ? "to" : "from"} your portfolio. Are you sure?
      </div>
      <div className="flex flex-row gap-2 justify-end w-full mt-6">
        <Button
          onClick={closeModal}
          smplus
          colorVariation="danger"
          variation="outline">
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSubmit();
            closeModal();
          }}
          isLoading={loading}
          smplus>
          Confirm and save
        </Button>
      </div>
    </Modal>
  );
}

export default ConfirmMediaKitChangesModal;
